<template>
  <div v-loading="loading">
    <div class="header">

      <bread-crumb-dynamic :items="brItems" @onClickItem="onClickBrItem"/>
      <div>
        <el-select class="select" v-model="info_type" @change="getStateBudgetIndicators">
          <el-option v-for="{type, title} in infoTypes" :key="type" :value="type"
                     :label="title"/>
        </el-select>
        <el-button v-if="brItems.length===1" type="primary" @click="$router.push({name: 'StateBudgetIndicatorFormAdd'})">Qo'shish</el-button>
      </div>
    </div>
    <el-table :data="tableData"
              border
              row-style="cursor:pointer"
              @rowClick="onClickRow"
              height="calc(100vh - 250px)">
      <el-table-column type="index" label="T/r"/>
      <el-table-column prop="title" label="Nomi"/>
      <el-table-column prop="created_at" label="Yaratilgan sanasi">
        <template #default="scope">
          {{ $moment(scope.row.created_at).format("DD.MM.YYYY") }}
        </template>
      </el-table-column>
      <el-table-column align="center">
        <template #default="scope">

          <el-button size="small" type="primary"
                     @click="$router.push({name: 'StateBudgetIndicatorParentFormAdd',params:{parent:scope.row.id}})">+
          </el-button>
          <el-button type="warning" size="small"
                     @click="$router.push({name: 'StateBudgetIndicatorFormEdit', params:{id: scope.row.id,parent:scope.row.parent_id}})">
            Tahrirlash
          </el-button>
          <el-button type="danger" size="small"
                     @click.stop="onClickDelete(scope.row.id)">O'chirish
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
          @current-change="getStateBudgetIndicators"
          background
          layout="prev, pager, next"
          :total="count"
          v-model:page-size="limit"
          v-model:current-page="page"
      />
    </div>
  </div>
</template>

<script>
import {ElMessage, ElMessageBox, ElNotification} from "element-plus";
import BreadCrumbDynamic from "@/components/BreadCrumbDynamic.vue";

export default {
  name: "StateBudgetList",
  components: {BreadCrumbDynamic},
  data() {
    return {
      loading: false,
      count: 0,
      page: 1,
      limit: 1,
      tableData: [],
      parent_id: null,
      info_type: 'INCOME',
      infoTypes: [{type: 'INCOME', title: 'Daromadlar'}, {type: 'EXPENSE', title: 'Xarajatlar'}]
    }
  },
  computed: {
    brItems() {
      return this.$store.state.brItems
    }
  },
  methods: {
    onClickDelete(id) {
      ElMessageBox.confirm(
          'Ma\'lumoitni o\'chirasizmi?',
          'Diqqat!',
          {
            confirmButtonText: 'Ha',
            cancelButtonText: 'Bekor qilish',
            type: 'warning',
          }
      )
          .then(() => {
            this.loading = true
            this.$http.delete(`/api/v1/state-budget-indicators/${id}`).then(() => {
              ElMessage({
                type: 'success',
                message: 'Muvaffaqqiyatli o\'chirildi',
              })
              this.getStateBudgetIndicators();
            }).catch(() => {
              ElNotification({
                type: 'error',
                title: 'Xatolik',
                message: 'Iltimos, qayta urinib ko\'ring',
              })
            }).finally(() => {
              this.loading = false
            })

          })
          .catch(() => {
            ElMessage({
              type: 'info',
              message: 'O\'chirish bekor qilindi',
            })
          })
    },
    onClickBrItem(id, index) {
      this.parent_id = id;
      this.$store.commit('sliceBrItems', index);
      this.getStateBudgetIndicators()
    },
    onClickRow(row) {
      this.parent_id = row['id'];
      this.$store.commit('updateBrItems', {
        id: row['id'],
        title: row['title']
      })
      this.getStateBudgetIndicators()
    },
    getStateBudgetIndicators() {
      this.loading = true
      this.$http.get(`api/v1/state-budget-indicators`, {
        params: {
          type: this.info_type,
          parent_id: this.parent_id,
          offset: (this.page - 1) * this.limit,
          limit: this.limit,
        }
      }).then(({data}) => {
        this.tableData = data.data;
        this.count = data.count;
      }).catch(({response}) => {
        ElNotification.error({
          message: response.data.message || "Ma'lmumot yuklasda xatolik sodir bo'ldi!"
        })
      }).finally(() => {
        this.loading = false
      })
    },

  },
  mounted() {
    this.$store.commit('clearBrItems')
    this.$store.commit('updateBrItems', {
      title: "Ko'rsatkichlar",
      id: null
    })
    this.getStateBudgetIndicators();
  }
}
</script>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  gap: 10px;
  align-items: center;

  .select {
    margin-right: 10px;
  }
}
.pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
</style>
